import React from 'react';



export default function NonCustomersDetailEd() {

  return (
    <>
        <h1>ТРИ ЯРУСА НЕКЛИЕНТОВ</h1>
        <p>На рисунке представлена модель трех ярусов неклиентов. Разница между ярусами заключается в сравнительной удаленности от вашего рынка.</p>
        <img src={`${process.env.PUBLIC_URL}/images/3. Non consum-ru.jpg`} style={{width: 600}}/>
        <p>
          Первый ярус – «Будущие неклиенты» - это те, кто минимально пользуется предложениями вашего рынка. Найдя более привлекательную альтернативу, они охотно обменяют ваши товары и услуги на нее.
        </p>

        <p>
          Второй ярус – «Неклиенты-отказники» - это те, кто рассматривал предложение вашей отрасли как один из вариантов удовлетворения возникшей у него потребности, но отказался от него.
        </p>

        <p>
          Третий ярус – «Неизученные неклиенты» - находятся от вашего рынка дальше всего. Как правило, они никогда не рассматривали вариант покупки продукта отрасли, а отрасль никогда не рассматривала их в качестве целевых или потенциальных потребителей.
        </p>
        <p>
          Цель инструмента – понять, кто еще может быть целевым потребителем вашего продукта помимо текущих клиентов отрасли, и как получить к ним доступ. Это позволяет выйти за рамки существующего спроса и увеличить размер Голубого Океана.
        </p>

        <h3>
          Алгоритм работы с инструментом:
        </h3>

        <p>
          1. Определите какие ярусы неклиентов могут быть в вашей отрасли, их поведение и потребности.
        </p>
        <p>
          2. Выберите те ярусы неклиентов, для которых вы будете формировать предложение.
        </p>
        <p>
          3. Дайте выбранным ярусам краткие названия, отражающие их основные характеристики, и разместите их на модели под соответствующим ярусом.
        </p>


        <h3>
          Правила работы с инструментом:
        </h3>

        <p>
          Правило выбора ярусов неклиентов одно – стремиться к максимально широкому охвату спроса. Можно выбрать как один ярус неклиентов, так и несколько, если между ними есть что-то общее.
        </p>

    </>
  )
}
